import React, { useRef, useState } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import FileInput from "./Components/FileInput";
import VideoPlayer from "./Components/VideoPlayer";
import Keyframes from "./Components/Keyframes";
import ReviewPage from "./Components/ReviewPage";
import { PlayerContext } from "./Components/PlayerContext";
import Navbar from "./Components/Navbar/Navbar";
import "./App.css";
import HomePage from "./Components/HomePages/HomePage";
import HomePageAuth from "./Components/HomePages/HomePageAuth";
import Profile from "./Components/ProfileSection/Profile";
import SideBar from "./Components/HomePages/SideBar";
import PricingPage from "./Components/Pricing/PricingPage";
import Classes from "./Components/sections/Classes";
import Programs from "./Components/sections/Programs";
import Categories from "./Components/sections/Categories";
import Instructors from "./Components/sections/Instructors";
import Saved from "./Components/sections/Saved";
import Community from "./Components/sections/Community";
import SelectRole from "./Components/SelectRole";
import { useAuth } from "./firebase/authContext";

const App = () => {
  const playerRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isLoggedIn } = useAuth();
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  // Add error handling for mobile navigation
  React.useEffect(() => {
    const handleError = (error) => {
      console.error("App error:", error);
    };

    const handleUnhandledRejection = (event) => {
      console.error("Unhandled promise rejection:", event.reason);
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <Router>
      <Navbar
        toggleSidebar={toggleSidebar}
        showLoginPopup={showLoginPopup}
        setShowLoginPopup={setShowLoginPopup}
      />
      <div className="flex">
        {/* Sidebar - Always Fixed */}
        {isLoggedIn && <SideBar isSidebarOpen={isSidebarOpen} />}

        {/* Main Content - Adjusts Width */}
        <div
          className={`flex-grow transition-all duration-300 ${
            isLoggedIn ? (isSidebarOpen ? "ml-64" : "ml-20") : "ml-0"
          } p-4 mt-16`}
        >
          <PlayerContext.Provider value={{ playerRef }}>
            <Routes>
              <Route
                path="/"
                element={
                  isLoggedIn ? (
                    <Navigate to="/review" />
                  ) : (
                    <HomePage setShowLoginPopup={setShowLoginPopup} />
                  )
                }
              />
              <Route
                path="/home"
                element={isLoggedIn ? <ReviewPage /> : <Navigate to="/" />}
              />
              <Route path="/profile/:userId" element={<Profile />} />
              <Route path="/classes" element={<Classes />} />
              <Route path="/programs" element={<Programs />} />
              {/* <Route path="/categories" element={<Categories />} />
              <Route path="/instructors" element={<Instructors />} />
              <Route path="/select-role" element={<SelectRole />} /> */}
              {/* <Route path="/playlists" element={<Playlists />} /> */}
              {/* <Route path="/schedule" element={<Schedule />} /> */}
              <Route path="/saved" element={<Saved />} />
              {/* <Route path="/history" element={<History />} />
              <Route path="/party" element={<Party />} /> */}
              <Route path="/community" element={<Community />} />
              <Route
                path="/labeling"
                element={
                  <div className="flex flex-row h-screen">
                    <div className="flex-1 relative">
                      <VideoPlayer />
                      <FileInput />
                    </div>
                    <div className="flex-1 overflow-y-auto">
                      <Keyframes />
                    </div>
                  </div>
                }
              />
              <Route
                path="/review"
                element={isLoggedIn ? <ReviewPage /> : <Navigate to="/" />}
              />
              <Route path="/pricing" element={<PricingPage />} />
            </Routes>
          </PlayerContext.Provider>
        </div>
      </div>
    </Router>
  );
};

export default App;
